export class Strings {
  static FieldRequired = 'This field is required';
  static PartyLocationWebLinkRequired = 'Party location or video web link is required';
  static ZoomLinkPattern = 'Must be a valid web link starting with http(s)://';
  static EmailPattern = 'Invalid email format';
  static RequestErrorMessage = 'This action cannot be completed right now. Please try again later.';
}
